import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { browserHistory } from 'react-router';
import { simplePlaceName, xlt } from '../../utils/utils';
import styles from './../ForecastEmbed/ForecastEmbed.css';
import withStyles from '../../decorators/withStyles';
import BarChart from '../BarChart';
import ForecastData from '../ForecastData';

const ForecastSlide = ({data, getGraphValues, graphTypes, chartExplain, slrModelDescriptions,  margin, width, height,
                        waterLevel, forecastName, subtitles, forecastType, placeName, stations, stationNum, textMap}) => {

  const isWaterLevel = forecastName !== "Multi-year" && forecastName !== "Single-year";
  const stnShortName = name => name.split("-")[0].trim();
  const stnDist = stations[stationNum].dist;
  const stnName = stnShortName(stations[stationNum].name);
  const yRange = data.forecastData[forecastName].levels[0].yRange;
  const slrModelDescription = isWaterLevel ? data.forecastSummary.hardwired12 : data.forecastSummary.hardwired36;
  const setTxContent = (el) => d3.select(el).attr('tx-content', 'block');

  return (
    <div className="ForecastSlide state-content">
      <h5 className="header supertitle graph-title">{simplePlaceName(placeName.split(",")[0]).toUpperCase()} AREA*</h5>
      <h1 className="header graph-title" style={{marginTop: -6}}>
        {graphTypes.find(type => type.value === forecastName).text}
      </h1>
      <h3 className="header graph-title">
        <span id="projection-details">{subtitles[forecastName]}</span>
      </h3>
      <div id="location" className="projection_chart_container">
        <BarChart
          data={getGraphValues(data, forecastName, waterLevel, textMap[forecastName])}
          waterLevel={waterLevel}
          isWaterLevel={isWaterLevel}
          margin={margin}
          width={width}
          height={height}
          xLabel={xlt(forecastName === "Multi-year" ? "End year" : "Year")}
          yLabel={xlt(isWaterLevel ? `Water Level (${waterLevel.unit.replace("m", "meters")})` : "Risk (% Likelihood)")}
        />
      </div>
      <p className="map-explain" ref={setTxContent}>*At <var>{stnName}</var> water level station, <var>{stnDist}</var> miles
        from <var>{xlt(simplePlaceName(placeName.split(",")[0]))}</var>
      </p>
      <p className="map-explain">
        {slrModelDescription}
        <span>&nbsp;</span>
        <span>Source: Climate Central Risk Finder, <var>{new Date().getFullYear()}</var>.</span>
        <span>&nbsp;</span>
        <a className="novisit" href="http://www.riskfinder.org/">http://www.riskfinder.org/</a>
      </p>
      <p className="map-explain" ref={setTxContent}>
        {chartExplain(data, forecastName, stnName)}
      </p>
      <div className="cc-logo-img" />
    </div>
  )
};

class ForecastEmbed extends Component {

  render() {
    const margin = {top: 20, right: 20, bottom: 55, left: 75};
    const width = 660 - margin.left - margin.right;
    const height = 350 - margin.top - margin.bottom;

    return (
      <div className="EmbedForecast band white">
        <section>
          <ForecastData>
            <ForecastSlide margin={margin} width={width} height={height} />
          </ForecastData>
        </section>
      </div>
    )
  }
}

export default compose(
  withStyles(styles),
  connect((state) => state),
)(ForecastEmbed);
